export default __webpack_public_path__ + "static/media/lock.4c75fe31.svg";